import {
  LOW_MARGIN_CONFIRMATION_MESSAGES,
  LOW_MARGIN_THRESHOLD,
} from '../constants/survey-target-margin.constants';

export type SurveyLowMarginConfirmationContext = {
  readonly margin: number;
};

export class SurveyLowMarginConfirmationInspector {
  public constructor(
    private readonly _context: SurveyLowMarginConfirmationContext,
  ) {}

  public check(): boolean {
    return !this._context.margin || this._context.margin < LOW_MARGIN_THRESHOLD;
  }

  public text(): string {
    return LOW_MARGIN_CONFIRMATION_MESSAGES.survey;
  }
}
